import React, { FC, useState } from "react";
import { FormControl, MenuItem, Select, SxProps, Theme, Typography } from "@mui/material";
import theme from "common/theme/theme";
import { menuItem } from "../menu/MenuDropdown";
import { GetFormControlSxProps } from "../toolbar/ToolbarSection";

interface IToolbarDropdownProps {
  menuItems: menuItem[];
  id: string;
  label: string;
  dropdownWidth: string;
  selectedValue: string | null;
  setSelectedValue: (value: string | null) => void;
  disabled?: boolean;
}

const ToolbarDropdown: FC<IToolbarDropdownProps> = ({
  menuItems,
  id,
  label,
  dropdownWidth,
  selectedValue,
  setSelectedValue,
  disabled,
}) => {
  const [hasFocus, setHasFocus] = useState<boolean>(false);

  const hasFocusOrSelectedValue = () => {
    return hasFocus || selectedValue !== null;
  };

  const GetDDFormControlSxProps = (): SxProps<Theme> => {
    const combinedStyle = {
      ...GetFormControlSxProps(),
      width: dropdownWidth,
    };
    return combinedStyle;
  };

  return (
    <FormControl sx={GetDDFormControlSxProps()}>
      <Typography variant="toolbarlabel" sx={{textAlign: "left", pb: "2px"}}>{label}</Typography>
      <Select
        id={id}
        sx={{
          bgcolor: theme.palette.common.white,
          color: theme.palette.common.black,
          width: "100%",
          alignSelf: "flex-end",
          height: "20px",
          borderRadius: "0",
          fontSize: "10px",
          "& .MuiSelect-icon": {
            right: "0px", // Reset the initial right positioning
          },
          '& .MuiOutlinedInput-input': { // Target the inner input
            paddingBottom:  '0 !important',
            paddingTop:  '0 !important',
            paddingLeft: '6px !important',
            paddingRight: '0 !important',
          },
          // '& .MuiMenuItem-root': { // Target the MenuItem component
          //    paddingBottom:  '2px !important',
          //    paddingTop: '2px !important',
          //  },
        }}
        disabled={disabled === true}
        size="small"
        onFocus={(e) => setHasFocus(true)}
        onBlur={(e) => setHasFocus(false)}
        value={selectedValue}
        onChange={(e) => setSelectedValue(e.target.value)}
      >
        {menuItems.map((item) => (
          <MenuItem key={item.key} value={item.key} sx={{ fontSize: "12px", pt: "2px", pb: "2px" }}>
            {item.value}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default ToolbarDropdown;
